/* eslint-disable no-useless-escape */
export default (youtube) => {
  const url = youtube.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  return url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
};
